import { useState, forwardRef, useImperativeHandle, useRef } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    FormGroup,
    FormControlLabel,
    Switch,
    FormControl,
    FormLabel,
    RadioGroup,
    Radio,
    Typography,
    LinearProgress,
    IconButton,
    ButtonGroup,
    Alert,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';



import { AddBox, Backspace, Delete, Edit, ErrorRounded, Save } from '@mui/icons-material';

import { makeid, myTimestampToDate, propComparator } from '../utils/ui_utils';
import { LoadingButton } from '@mui/lab';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { add_Event, edit_Event } from '../FirebaseUtils/dbEvent';
import { PersonalDataForm } from '../components/PersonalDataForm';
import { useAuth } from '../core/AuthProvider';
import { newevent, event_category_list, event_type_list } from '../definitions/event';
import { differenceInDays } from 'date-fns';
import { MyInput } from '../components/MyInput';
import { MyCloseBtn } from '../components/MyButtons';
import { globalstyles } from '../lib/definitions';
import { upload_file } from '../FirebaseUtils/dbFile';
import { CustomCowFilterParamDialog } from './CustomCowFilterParamDialog';
import { NumberInput } from '../components/NumberInput';






export const EventDialog = forwardRef(({ reloadFn, }, ref) => {
    const [open, setOpen] = useState(false);
    const [curElement, setCurElement] = useState({ ...newevent })
    const { user } = useAuth()
    const [isEdited, setIsEdited] = useState(false)
    const [isSaving, setIsSaving] = useState(false)
    const [isInvalid, setIsInvalid] = useState(false)
    const [is_new, setIsNew] = useState(false)
    const [index, setIndex] = useState(-1)
    const [uploadingState, setUploadingState] = useState(-1)
    const [showError, setShowError] = useState()






    useImperativeHandle(ref, () => {
        return {
            onNew() {
                setCurElement({ ...newevent, event_code: makeid(8, true) })
                setIndex(-1)
                setIsNew(true)
                setIsEdited(false)
                setOpen(true);
                setShowError(false)
            },
            onEdit(el, i, is_c) {
                console.log("IS CURRENT", is_c)
                setOpen(true);
                setIsNew(false)
                let _el = { ...newevent, ...el }
                setCurElement(_el)
                setIndex(i)
                setIsEdited(false)
                setShowError(false)
            }
        }
    })


    const handleClose = () => {
    console.log("dataUSER", user)
        setOpen(false);
    };

    // -------------------
    const cb_progress = (status, byte, total) => {
        console.log(status, byte, total)
        try {
            if (byte < total) {
                setUploadingState(100 * byte / total)
            } else {
                setUploadingState(-1)
            }

        } catch (e) {
            console.warn("handleSaveMedia - error: ", e)
        }
    }

    // ------------------
    const handleSave = async () => {
        console.log("USER", user)
        const cb_error = (c) => {
            console.log("ERROR DB", c)
            setShowError(c)
        }


        const cb_save = (file_url) => {
            console.log("SAVE END", file_url)
            if (file_url) {
                curElement.logo = file_url
            }
            delete curElement.file

            if (is_new) {
                add_Event(user.uid, curElement, cb_error)
                reloadFn()
            } else {
                if (curElement.id) {
                    edit_Event(user.uid, curElement.id, curElement, cb_error)
                    reloadFn(curElement)
                }
            }
            setOpen(false)
        }

        if (curElement.file) {
            const storagepath = "events/" + curElement.id + "/" + curElement.file[0].name;
            console.log(curElement.file, curElement.file[0])
            //const mediainfo = { source_name: curElement.file[0].name, destinationName: curElement.name }
            upload_file(curElement.file[0], storagepath, curElement.file[0].contentType, cb_progress, cb_save, cb_error);
            //    uploadFileComplete(PATH, curElement.file[0], curElement.file[0].contentType, mediainfo, { cbProgress: cb_progress, cbSetDownload: cb_save })
        } else {
            cb_save()
        }
    }



    const onChangeHandler = (el, level) => {
        let { name, value, type } = el
        console.log(el)
        console.log(name, value, type)
        if (type === 'radio') {
            if (value === 'true') {
                value = true
            } else if (value === 'false') {
                value = false
            }
        } else if (type === 'checkbox') {
            value = el.checked

        }
        if (name === 'file' || value !== undefined) {
            setCurElement({ ...curElement, [name]: value })
            setIsEdited(true)
        }
    }













    return (
        <div>
            <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth={true}>
                <DialogTitle>
                    Dati Evento:  {curElement.event_name}
            {showError &&
                <Alert icon={<ErrorRounded fontSize="inherit" />} severity="error" >
                    Errore nel caricamento del logo 
                    ({showError.name} {showError.status_}: {showError.code})
                </Alert>
            }
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ width: '100%' }}>

                        <MyInput
                            id="event_name"
                            label={'Nome'}
                            value={curElement.event_name}
                            onChange={(ev) => onChangeHandler(ev.target, -1)}
                        />

                        <MyInput
                            id="event_description"
                            label={'descrizione'}
                            value={curElement.event_description}
                            onChange={(ev) => onChangeHandler(ev.target, -1)}
                        />
                        <MyInput
                            id="id_protocol"
                            label={'ID protocollo'}
                            value={curElement.id_protocol}
                            onChange={(ev) => onChangeHandler(ev.target, -1)}
                        />
                        <MyInput
                            id="note"
                            label={'note'}
                            value={curElement.note}
                            onChange={(ev) => onChangeHandler(ev.target, -1)}
                        />
                        <FormControl>
                            <FormLabel id="evtype-radio-buttons-group-label">Tipo di evento</FormLabel>
                            <RadioGroup
                                name="event_type"
                                size="dense"
                                value={curElement.event_type}
                                onChange={(ev) => onChangeHandler(ev.target, -1)}
                                sx={{
                                    '& .MuiSvgIcon-root': {
                                        fontSize: 10,
                                    },
                                }}
                            >
                                {event_type_list.map((e, k) => (
                                    <FormControlLabel sx={{ color: curElement.event_type === e.id ? 'blue' : 'black' }} key={k} value={e.id} control={<Radio />} label={e.label} />
                                ))}
                            </RadioGroup>
                        </FormControl>
                        <FormControl>
                            <FormLabel id="evcategory-radio-buttons-group-label">Categoria evento</FormLabel>
                            <RadioGroup
                                name="event_category"
                                value={curElement.event_category}
                                onChange={(ev) => onChangeHandler(ev.target, -1)}
                                sx={{
                                    '& .MuiSvgIcon-root': {
                                        fontSize: 10,
                                    },
                                }}
                            >
                                {event_category_list.map((e, k) => (
                                    <FormControlLabel sx={{ color: curElement.event_category === e.id ? 'blue' : 'black' }} key={k} value={e.id} control={<Radio />} label={e.label} />

                                ))}
                            </RadioGroup>
                        </FormControl>
                        <FormGroup sx={{ mt: 1, mb: 1 }}>
                            <DatePicker
                                slotProps={{ field: { size: 'small' } }}
                                variant="outlined" label="inizio evento" name="event_start" id="event_start" value={myTimestampToDate(curElement.event_start)} onChange={(nv) => onChangeHandler({ value: nv, name: 'event_start' })} />
                        </FormGroup>
                        <FormGroup sx={{ mt: 1, mb: 1 }}>
                            <DatePicker
                                slotProps={{ field: { size: 'small' }, textField: { helperText: differenceInDays(myTimestampToDate(curElement.event_end), myTimestampToDate(curElement.event_start)) < 0 ? 'data non valida' : '' } }}
                                variant="outlined" label="fine evento" name="event_end" id="event_end" value={myTimestampToDate(curElement.event_end)} onChange={(nv) => onChangeHandler({ value: nv, name: 'event_end' })} />
                        </FormGroup>
                        <PersonalDataForm section_title={"Luogo"} type={"address"} curElement={curElement.location || {}} setCurElement={(v) => onChangeHandler({ name: 'location', value: v })} />
                        <PersonalDataForm section_title={"Giudice"} curElement={curElement.judge || {}} setCurElement={(v) => onChangeHandler({ name: 'judge', value: v })} />
                        <Box sx={globalstyles.list_container}>
                            <Typography sx={globalstyles.sectionHeader}>
                                Logo personalizzato {!curElement.id && <i>(Salvare l'evento per poter inserire un logo)</i>}
                            </Typography>
                            {curElement.id && <>

                                {curElement.file &&
                                    <Grid container>
                                        <Grid>{curElement.file[0].name}
                                        </Grid>
                                        <Grid>
                                            <IconButton size="small" color="secondary" onClick={() => onChangeHandler({ name: 'file', value: '' })}><Backspace /> </IconButton>
                                        </Grid>
                                    </Grid>
                                }
                                {curElement.logo
                                    ?
                                    <>
                                        <img style={{ height: '50px' }} src={curElement.logo} />
                                        <Button variant="outlined" size="small" color="error" onClick={() => onChangeHandler({ name: 'logo', value: '' })} startIcon={<Delete />}>cancella logo</Button>
                                    </>
                                    :
                                    <></>
                                }
                                <Button
                                    variant="contained"
                                    component="label"
                                    size="small"
                                >
                                    {curElement.logo ?
                                        'sostituisci logo'
                                        :
                                        'carica logo personalizzato'
                                    }
                                    <input
                                        type="file"
                                        hidden
                                        name="file"
                                        onChange={(event) => onChangeHandler({ name: 'file', value: event.target.files })}
                                    />
                                </Button>
                                {uploadingState > -1 ?
                                    <Box>
                                        <LinearProgress variant="determinate" value={uploadingState} label={`${uploadingState.toFixed(1)}%`} />
                                    </Box>
                                    : <></>}
                            </>}
                        </Box>
                        <Box sx={globalstyles.list_container}>
                            <Typography sx={globalstyles.sectionHeader}>
                                Stampe
                            </Typography>
                            <Grid container>
                                <Grid size="grow">
                                    <FormGroup>
                                        <FormControlLabel control={<Switch color="secondary" name="signboard_show_logo" checked={curElement.signboard_show_logo} onChange={(ev) => onChangeHandler(ev.target)} inputProps={{ 'aria-label': 'controlled' }}
                                        />} label={"logo ANAFIBJ su cartello"} />
                                    </FormGroup>
                                    <FormGroup>
                                        <FormControlLabel control={<Switch color="secondary" name="number_show_logo" checked={curElement.number_show_logo} onChange={(ev) => onChangeHandler(ev.target)} inputProps={{ 'aria-label': 'controlled' }}
                                        />} label={"logo ANAFIBJ su pettorale"} />
                                    </FormGroup>
                                    <FormGroup>
                                        <FormControlLabel control={<Switch color="secondary" name="catalog_show_logo" checked={curElement.catalog_show_logo} onChange={(ev) => onChangeHandler(ev.target)} inputProps={{ 'aria-label': 'controlled' }}
                                        />} label={"logo ANAFIBJ su catalogo"} />
                                    </FormGroup>
                                    <FormGroup>
                                        <FormControlLabel control={<Switch color="secondary" name="document_show_logo" checked={curElement.document_show_logo} onChange={(ev) => onChangeHandler(ev.target)} inputProps={{ 'aria-label': 'controlled' }}
                                        />} label={"logo ANAFIBJ su documenti"} />
                                    </FormGroup>
                                    <FormGroup>
                                        <FormControlLabel control={<Switch color="secondary" name="screen_show_logo" checked={curElement.screen_show_logo} onChange={(ev) => onChangeHandler(ev.target)} inputProps={{ 'aria-label': 'controlled' }}
                                        />} label={"logo ANAFIBJ su schermo esterno esterno"} />
                                    </FormGroup>
                                </Grid>

                                <Grid size="grow">
                                    <FormGroup>
                                        <FormControlLabel disabled={curElement.file === undefined && curElement.logo === undefined} control={<Switch color="secondary" name="signboard_show_customlogo" checked={curElement.signboard_show_customlogo} onChange={(ev) => onChangeHandler(ev.target)} inputProps={{ 'aria-label': 'controlled' }}
                                        />} label={"logo personalizzato su cartello"} />
                                    </FormGroup>
                                    <FormGroup>
                                        <FormControlLabel disabled={curElement.file === undefined && curElement.logo === undefined} control={<Switch color="secondary" name="number_show_customlogo" checked={curElement.number_show_customlogo} onChange={(ev) => onChangeHandler(ev.target)} inputProps={{ 'aria-label': 'controlled' }}
                                        />} label={"logo personalizzato su pettorale"} />
                                    </FormGroup>
                                    <FormGroup>
                                        <FormControlLabel disabled={curElement.file === undefined && curElement.logo === undefined} control={<Switch color="secondary" name="catalog_show_customlogo" checked={curElement.catalog_show_customlogo} onChange={(ev) => onChangeHandler(ev.target)} inputProps={{ 'aria-label': 'controlled' }}
                                        />} label={"logo personalizzato su catalogo"} />
                                    </FormGroup>
                                    <FormGroup>
                                        <FormControlLabel disabled={curElement.file === undefined && curElement.logo === undefined} control={<Switch color="secondary" name="document_show_customlogo" checked={curElement.document_show_customlogo} onChange={(ev) => onChangeHandler(ev.target)} inputProps={{ 'aria-label': 'controlled' }}
                                        />} label={"logo personalizzato su documenti"} />
                                    </FormGroup>
                                    <FormGroup>
                                        <FormControlLabel disabled={curElement.file === undefined && curElement.logo === undefined} control={<Switch color="secondary" name="screen_show_customlogo" checked={curElement.screen_show_customlogo} onChange={(ev) => onChangeHandler(ev.target)} inputProps={{ 'aria-label': 'controlled' }}
                                        />} label={"logo personalizzato su schermo esterno esterno"} />
                                    </FormGroup>
                                </Grid>
                            </Grid>
                        </Box>
                        <CustomCowFilterParamSection curElement={curElement} onChangeHandler={onChangeHandler} />
                        <FormGroup>
                            <FormControlLabel control={<Switch color="secondary" name="is_public" checked={curElement.is_public} onChange={(ev) => onChangeHandler(ev.target)} inputProps={{ 'aria-label': 'controlled' }}
                            />} label={"Evento Pubblico"} />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel control={<Switch name="lock_catalog" checked={curElement.lock_catalog} onChange={(ev) => onChangeHandler(ev.target)} inputProps={{ 'aria-label': 'controlled' }}
                            />} label={"Blocca catalogo"} />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel control={<Switch color="error" name="is_archived" checked={curElement.is_archived} onChange={(ev) => onChangeHandler(ev.target)} inputProps={{ 'aria-label': 'controlled' }}
                            />} label={"archivia"} />
                        </FormGroup>
                        {user.uid === "RMjMZx8WtpTskSPP55yVobdXl293" &&
                        <FormGroup>
                            <FormControlLabel control={<Switch color="error" name="is_debug" checked={curElement.is_debug} onChange={(ev) => onChangeHandler(ev.target)} inputProps={{ 'aria-label': 'controlled' }}
                            />} label={"DEBUG (only dev)"} />
                        </FormGroup>
                        }

                    </Box>
                    <NumberInput
                        value={curElement.old_cow_first_category || 7}
                        label={'Prima categoria vacche'}
                        name="old_cow_first_category"
                        onChangeHandler={onChangeHandler}
                        setCurElement={setCurElement}
                        setIsEdited={setIsEdited}
                    />
                </DialogContent>
                <DialogActions>
                    <MyCloseBtn handleClose={handleClose} />
                    {isEdited &&
                        <LoadingButton key={'bs'} disabled={isInvalid} onClick={handleSave} startIcon={<Save />} variant="contained" color="secondary" loading={isSaving} loadingPosition="start">salva</LoadingButton>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
})



const CustomCowFilterParamSection = ({ curElement, onChangeHandler }) => {
    const modalRef = useRef()
    const { user } = useAuth()
    const handleNew = () => {
        modalRef.current.onNew(curElement.custom_cow_filter_param_list)
    }
    const handleEdit = (el, k) => {
        modalRef.current.onEdit(el, k)
    }

    const add_param = (e) => {
        let _list = curElement.custom_cow_filter_param_list ? [...curElement.custom_cow_filter_param_list] : []
        _list.push(e)
        onChangeHandler({ name: 'custom_cow_filter_param_list', value: _list })
    }

    const edit_param = (e, index) => {
        let _list = curElement.custom_cow_filter_param_list ? [...curElement.custom_cow_filter_param_list] : []
        _list.splice(index, 1, e)
        onChangeHandler({ name: 'custom_cow_filter_param_list', value: _list })

    }
    const handleDelete = (el, k) => {
        let _label_list = curElement.custom_cow_filter_param_list ? [...curElement.custom_cow_filter_param_list] : []
        _label_list.splice(k, 1)
        onChangeHandler({ name: 'custom_cow_filter_param_list', value: _label_list })
    }




    return (
        <Grid sx={globalstyles.list_container}>
            <CustomCowFilterParamDialog ref={modalRef} add_param={add_param} edit_param={edit_param} />
            <Grid container sx={globalstyles.sectionHeader}>
                <Grid size={"grow"}>
                    Campi-filtro personalizzati
                </Grid>
                <Grid size={"auto"}>
                    <ButtonGroup>
                        <Button variant="contained" size="small" onClick={handleNew} startIcon={<AddBox />}>Nuovo campo</Button>
                    </ButtonGroup>
                </Grid>
            </Grid>
            {!curElement.custom_cow_filter_param_list || curElement.custom_cow_filter_param_list.length === 0 ?
                <i>Nessun campo personalizzato inserito</i>
                :
                <>
                    <Grid container sx={globalstyles.listHeader}>
                        <Grid size={"grow"}>
                            nome parametro
                        </Grid>
                    </Grid>
                    {curElement.custom_cow_filter_param_list?.map((a, k) => (
                        <Grid key={k} container sx={globalstyles.list_row}>
                            <Grid size={"grow"} sx={{ fontWeight: 'bold' }}>
                                {a.param_name}
                            </Grid>
                            <Grid size={"auto"}>
                                <ButtonGroup size="small">
                                    <Button color="warning" onClick={() => handleEdit(a, k)} startIcon={<Edit />}></Button>
                                    <Button color="error" onClick={() => handleDelete(a, k)} startIcon={<Delete />}></Button>
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                    ))}
                </>
            }

        </Grid>
    )
}





